import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { environment } from '../environments/environment';
import { UserService } from 'src/app/services/user.service';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';

type HttpMethod = 'get' | 'post' | 'put' | 'patch' | 'head' | 'delete' | 'upload' | 'download';

@Injectable()
export class NativeHttpInterceptor implements HttpInterceptor {
  constructor(
    private nativeHttp: HTTP,
    private platform: Platform,
    private storage: Storage,
    private userService: UserService
  ) { }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {    
    if (!this.platform.is('cordova')) {
      let token = this.userService.getAuthToken();
      let headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }

      if(token) {
        headers["x-access-token"] = token;        
      }      
      
      let authenticatedRequest = request.clone({setHeaders: headers})
      return next.handle(authenticatedRequest);
    } else {
      return from(this.handleNativeRequest(request));
    }
  }

  private async handleNativeRequest(request: HttpRequest<any>): Promise<HttpResponse<any>> {
    let token = this.userService.getAuthToken();
    const headerKeys = request.headers.keys();
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };

    if(token) {
      headers["x-access-token"] = token;
    }

    headerKeys.forEach((key) => {
      headers[key] = request.headers.get(key);
    });

    try {
      await this.platform.ready();

      const method = <HttpMethod> request.method.toLowerCase();
      const nativeHttpResponse = await this.nativeHttp.sendRequest(request.url, {
        method: method,
        data: request.body,
        headers: headers,
        serializer: 'json',
      });

      let body;
      try {
        body = JSON.parse(nativeHttpResponse.data);
      } catch (error) {
        body = { response: nativeHttpResponse.data };
      }

      const response = new HttpResponse({
        body: body,
        status: nativeHttpResponse.status,
        headers: new HttpHeaders(nativeHttpResponse.headers),
        url: nativeHttpResponse.url,
      });

      // console.log(`returning from http request, body: ${JSON.stringify(body)}`)
      return Promise.resolve(response);
    } catch (error) {
      if (!error.status) { return Promise.reject(error); }

      const response = new HttpResponse({
        body: JSON.parse(error.error),
        status: error.status,
        headers: error.headers,
        url: error.url,
      });

      return Promise.reject(response);
    }
  }

  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }
}
